import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-coming-soon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="h-full w-full flex flex-col items-center justify-center bg-white dark:bg-black p-8 text-center animate-fade-in-up transition-colors duration-500">
      
      <div class="relative flex items-center justify-center mb-8">
        <div class="absolute w-48 h-48 bg-ionet-500/10 rounded-full animate-ping opacity-75"></div>
        <div class="absolute w-32 h-32 bg-ionet-500/20 rounded-full animate-pulse"></div>
        
        <div class="relative z-10 w-20 h-20 bg-gradient-to-tr from-ionet-400 to-ionet-600 rounded-full shadow-[0_0_30px_rgba(16,185,129,0.4)] flex items-center justify-center">
           <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
             <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
           </svg>
        </div>
      </div>

      <h2 class="text-3xl font-bold text-gray-900 dark:text-white mb-3 tracking-tight transition-colors">
        Próximamente...
      </h2>
      <p class="text-gray-500 dark:text-gray-400 max-w-md mx-auto text-sm leading-relaxed transition-colors">
        Nuestros ingenieros de IA están calibrando los neuro-circuitos de la función 
        <span class="font-bold text-ionet-600 dark:text-ionet-400">{{ featureName() }}</span>. 
        Vuelve pronto para descubrir su máximo potencial.
      </p>
    </div>
  `
})
export class ComingSoonComponent {

  readonly featureName = input.required<string>();
}